module.exports = __webpack_public_path__ + "img/1015_pc.4fd1470d.gif";